import { useSelector } from 'react-redux';

const DEFAULT_BACKGROUND = '/assets/images/home-background.png';
const DEFAULT_LOGO = '/assets/images/sign-in-logo.png';
export const useThemeAssets = () => {
  const { appTheme } = useSelector((state) => state.auth);
  return {
    logo: appTheme?.logoImage || DEFAULT_LOGO,
    loginBackground: appTheme?.backgroundImage || DEFAULT_BACKGROUND,
  };
};